import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  fixedMenu:false,//固定头部按钮栏
	  reportRightStyle:'',//分析报告的 侧边按钮栏的右侧定位
	  showHeader:true,//显示头部
	  rightFixedbottom:false,//预警舆情左侧固定逻辑
	  iscloseWarning:true,// 是否关闭预警弹窗
	  ifBack:false, //true 后台  false 客户，
	  isReadonly:false,//非只读
  },
  mutations: {
	  toggleFixedMenu(state,val){
		  state.fixedMenu = val
	  },
	   toggleshowHeader(state,val){
		   state.showHeader = val
	   },
	   setReportRightStyle(state,val){
		   let top = 68 + val
		   if(top> 4500){
			   top = 4500
		   }
		   state.reportRightStyle = `top:${top}px`
	   },
	   toggleRightFixedbottom(state,val){
		   state.rightFixedbottom = val
	   },
	   closeWarning(state,val){
		    state.iscloseWarning = val
	   },
	   setIfBack(state,val){
		   state.ifBack = val
	   },
	   setIsReadonly(state,val){
		   state.isReadonly = val
	   }
  },
  actions: {
  },
  modules: {
  }
})
